import { t } from '../i18n';

function labelKey(value: unknown): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export function translatePaymentName(name: unknown, type?: string, paymentId?: string): string {
  const fallback = String(name ?? '').trim();
  if (String(paymentId ?? '') === '200') return t('paymentMethod.bitcoin', fallback || 'Bitcoin');
  if (type === 'echeque') return t('paymentMethod.echeque', fallback || 'E-check');
  if (!fallback) return t('confirm.notSelected');
  return t(`paymentMethod.${labelKey(fallback)}`, fallback);
}

export function translateCardType(cardType: string): string {
  return t(`paymentCard.${labelKey(cardType)}`, cardType);
}
